export default "__VITE_ASSET__BaRls9iv__"